import React from 'react';
import cx from 'classnames';
import Alert from '../Alert';
import LoadingBar from '../LoadingBar';
function PageLayout({ children, className, header, footer }) {
  return (
    <main className={cx('page', className)}>
      <LoadingBar />
      {header}
      <Alert />

      {children}
      {footer}
    </main>
  );
}
export default PageLayout;
